module.exports = __webpack_public_path__ + "img/ic-flag-usa.a753d665.svg";